import React, { useState, useEffect, useRef } from "react";
import YouTube from "react-youtube";
import Home from "../../common/Home/Home";
import ScreenSize from "../../screen-size/ScreenSize";
import { useNavigate } from "react-router-dom";
import './AddVideo.css';
import adimg from "../../assets/rtm-ad.png";

const AddVideo = ({ onLogout }) => {
  // Configuration from environment variables
  const interval =  100000;
  const isVideoEnabled = true;
  const isImageEnabled = false;
  const isHomeEnabled = false;

  // const videoIds = ["YKsQJVzr3a8", "1O0yazhqaxs"];
  const videoIds = ["mHpcNPgGBug", "eA9LMBKk-RI", "u_4MZ2nNRhg", "AV49pSWMUjI", "lR9P0uIeI7w", "yoXiTXOLAgs", "EQ0xQtYi6Bo", "mzBhpjB8Cns", "atA0oOccfGw", "m5zdG_ezU4w"];
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(isVideoEnabled);
  const [showComponent, setShowComponent] = useState(!isVideoEnabled && isHomeEnabled);
  const [showSignOut, setShowSignOut] = useState(true);
  const [showImage, setShowImage] = useState(false);

  const navigate = useNavigate();
  const signOutTimeoutRef = useRef(null);
  useEffect(() => {
    const handleMouseMove = () => {
      setShowSignOut(true);
      clearTimeout(signOutTimeoutRef.current);
      signOutTimeoutRef.current = setTimeout(() => {
        setShowSignOut(false);
      }, 5000);
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      clearTimeout(signOutTimeoutRef.current);
    };
  }, [showSignOut]);
  const handleLogout = () => {
    onLogout();
    navigate("/");
  };
  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1,
      controls: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      mute: 1,
      playsinline: 1,
      cc_load_policy: 3,
      cc_lang_pref: 'none',
      iv_load_policy: 3,
      fs: 0,
      disablekb: 1,
      origin: window.location.origin,
      enablejsapi: 1,
      host: 'https://www.youtube.com',
      vq: 'hd1080',
      hd: 1,
      quality: 'highres'
    },
  };
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .youtube-container iframe {
        position: absolute;
        top: -60px !important;
        left: 0;
        width: 100vw !important;
        height: calc(100vh + 120px) !important;
        pointer-events: none !important;
      }
      .video-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .ytp-chrome-top,
      .ytp-chrome-bottom,
      .ytp-watermark,
      .ytp-caption-window-container,
      .ytp-caption-segment,
      .captions-text,
      .ytp-caption-window,
      .ytp-subtitles-button,
      .ytp-subtitles-button-icon,
      .ytp-show-cards-title {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // Add rotation effect when videos are disabled
  useEffect(() => {
    if (!isVideoEnabled) {
      const rotationInterval = setInterval(() => {
        if (showComponent && isHomeEnabled) {
          setShowComponent(false);
          if (isImageEnabled) {
            setShowImage(true);
          }
        } else if (showImage && isImageEnabled) {
          setShowImage(false);
          if (isHomeEnabled) {
            setShowComponent(true);
          }
        }
      }, interval);

      return () => clearInterval(rotationInterval);
    }
  }, [isVideoEnabled, showComponent, showImage, interval, isHomeEnabled, isImageEnabled]);

  const handleReady = (event) => {
    const player = event.target;
    player.playVideo();
    player.setPlaybackQuality("highres");

    setTimeout(() => {
      try {
        player.unMute();
        player.setVolume(100);
        player.setPlaybackQuality("highres");
      } catch (error) {
        console.error("Error unmuting:", error);
      }
    }, 1000);
  };

  const handleVideoEnd = () => {
    if (!isVideoEnabled) return;
    
    setShowVideo(false);
    if (isHomeEnabled) {
      setShowComponent(true);  // Show content (e.g., text or home page)

      setTimeout(() => {
        setShowComponent(false); // Hide content
        if (isImageEnabled) {
          setShowImage(true);      // Show image

          setTimeout(() => {
            setShowImage(false);     // Hide image
            setShowVideo(true);      // Start next video
            setCurrentVideoIndex((prev) => (prev + 1) % videoIds.length);
          }, interval); // Image is displayed for configured interval
        } else {
          setShowVideo(true);      // Start next video directly
          setCurrentVideoIndex((prev) => (prev + 1) % videoIds.length);
        }
      }, interval); // Content is displayed for configured interval
    } else if (isImageEnabled) {
      setShowImage(true);      // Show image directly
      setTimeout(() => {
        setShowImage(false);     // Hide image
        setShowVideo(true);      // Start next video
        setCurrentVideoIndex((prev) => (prev + 1) % videoIds.length);
      }, interval);
    } else {
      setShowVideo(true);      // Start next video directly
      setCurrentVideoIndex((prev) => (prev + 1) % videoIds.length);
    }
  };


  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >

      {/* **Video Section** */}
      {showVideo && isVideoEnabled && (
        <div className="video-wrapper">
          <div className="youtube-container" style={{ position: "relative", paddingTop: "56.25%" }}>
            <YouTube
              videoId={videoIds[currentVideoIndex]}
              opts={opts}
              onReady={handleReady}
              onEnd={handleVideoEnd}
              className="youtube-player"
            />
          </div>
        </div>
      )}

      {/* **Image Section** */}
      {showImage && isImageEnabled && (
        <img
          src={adimg}
          alt="RTM Ad"
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "cover"
          }}
        />
      )}

      {/* **Home Component Section** */}
      {showComponent && isHomeEnabled && <Home onLogout={onLogout} />}

      <ScreenSize />

    </div>
  );
};

export default AddVideo;



